import whatInput from "what-input";

whatInput.ignoreKeys([
  16, // shift
  17, // control
  18, // alt
  27, // escape
  91, // Windows key / left Apple cmd
  93, // Windows menu / right Apple cmd
]);
